var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "16px",
    viewBox: "0 0 30 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/show") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-with-placeholder",
    transform: "translate(-793.000000, -397.000000)",
    fill: "#279CF7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/show",
    transform: "translate(793.000000, 397.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8818257,7.62883296 C26.4378005,2.83926348 20.8990872,0 14.9998257,0 C9.10056431,0 3.56185095,2.83926348 0.117825743,7.62883296 C-0.0392752477,7.85121947 -0.0392752477,8.14844645 0.117825743,8.37083296 C3.56185095,13.1604024 9.10056431,15.9996659 14.9998257,15.9996659 C20.8990872,15.9996659 26.4378005,13.1604024 29.8818257,8.37083296 C30.0389267,8.14844645 30.0389267,7.85121947 29.8818257,7.62883296 Z M14.9998257,13.118833 C12.185242,13.0655002 9.94166331,10.7499203 9.97723451,7.93505605 C10.0128057,5.12019181 12.3141822,2.8620461 15.1292148,2.87985434 C17.9442475,2.89766258 20.2168257,5.18474397 20.2168257,7.99983296 C20.1893416,10.8538609 17.8538618,13.1454694 14.9998257,13.118833 L14.9998257,13.118833 Z",
    id: "Show"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.de83d1c10225f61d29c5c724e375fb5f.svg";
export { ForwardRef as ReactComponent };